import api from './api';
import { LoyaltyScheduleDTO } from '../types/LoyaltySchedule';
import { AmortizationScheduleDTO } from '../types/AmortizationSchedule';

// Transforma AmortizationScheduleDTO a LoyaltyScheduleDTO (extrae solo campos de fidelización)
const transformToLoyalty = (data: AmortizationScheduleDTO): LoyaltyScheduleDTO => {
  return {
    productId: data.productId,
    productName: data.productName,
    productType: data.productType,
    phases: data.phases.map(phase => ({
      phaseId: phase.phaseId,
      phaseName: phase.phaseName,
      frecuenciaPago: phase.frecuenciaPago,
      fechaInicioFase: phase.fechaInicioFase,
      fechaDevolucion: phase.fechaDevolucion,
      periodLabels: phase.periodLabels,
      periodDates: phase.periodDates,
      investors: phase.investors.map(inv => ({
        rowNumber: inv.rowNumber,
        investorName: inv.investorName,
        sheetId: inv.sheetId,
        importe: inv.importe,
        fidelizacionPercent: inv.fidelizacionPercent,
        hastaFecha: inv.hastaFecha,
        fidelizacionTotalEur: inv.fidelizacionTotalEur,
        fechaInicioPago: inv.fechaInicioPago,
        periodPayments: inv.periodPayments,
      })),
      subtotal: {
        totalImporte: phase.subtotal.totalImporte,
        totalFidelizacionEur: phase.subtotal.totalFidelizacionEur,
        totalPeriodPayments: phase.subtotal.totalPeriodPayments,
      },
    })),
    grandTotal: {
      totalImporte: data.grandTotal.totalImporte,
      totalFidelizacionEur: data.grandTotal.totalFidelizacionEur,
      totalPeriodPayments: data.grandTotal.totalPeriodPayments,
    },
  };
};

export const loyaltyService = {
  getCrvLoyalty: async (productId: string) => {
    const response = await api.get<AmortizationScheduleDTO>(`/amortization-schedule/loyalty/crv/${productId}`);
    return {
      ...response,
      data: transformToLoyalty(response.data),
    };
  },
  getPhLoyalty: async (productId: string) => {
    const response = await api.get<AmortizationScheduleDTO>(`/amortization-schedule/loyalty/ph/${productId}`);
    return {
      ...response,
      data: transformToLoyalty(response.data),
    };
  },
};
